// @flow

import * as React from 'react';
import styled from '@emotion/styled';

import Clickable from 'app/components/commons/Clickable';
import Icon from 'app/components/commons/Icon';

type Props = {
  max: number,
  value: number,
  onMinus: e => void,
  onPlus: e => void
};

const Wrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

const Button = styled(Clickable)(({ theme, disabled }) => ({
  width: 30,
  height: 30,
  backgroundColor: theme.color.basis5,
  color: theme.color.basis1,
  opacity: disabled ? 0.5 : 1
}));

const Value = styled.span({
  padding: '0 0.5em'
});

class Counter extends React.PureComponent<Props> {
  props: Props;

  render() {
    const { value, max, onMinus, onPlus } = this.props;
    return (
      <Wrapper>
        <Button disabled={value === 0} onClick={onMinus}>
          <Icon type="icon-minus-ios" />
        </Button>
        <Value>{value}</Value>
        <Button disabled={value === max} size="xs" onClick={onPlus}>
          <Icon type="icon-plus-ios" />
        </Button>
      </Wrapper>
    );
  }
}

export default Counter;
